import React from "react";
import styled from "styled-components/macro";
import Close from "@material-ui/icons/Close";
import { theme } from "./theme";

const BulkActionBar = ({ count, onCancel, onClear }) => {
  if (!count) return null;

  return (
    <Wrapper>
      <Count>{count} selected</Count>
      <Divider />
      <ActionBtn danger onClick={onCancel}>
        Cancel jobs
      </ActionBtn>
      <ClearBtn onClick={onClear} aria-label="Clear selection">
        <Close style={{ fontSize: 16 }} />
      </ClearBtn>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: ${theme.text};
  color: #ffffff;
  border-radius: ${theme.radiusPill};
  box-shadow: ${theme.shadowHover};
  font-family: ${theme.fontFamily};
  z-index: 20;
`;

const Count = styled.div`
  font-size: 13px;
  font-weight: 600;
  padding-left: 6px;
`;

const Divider = styled.div`
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.2);
`;

const ActionBtn = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  font-family: ${theme.fontFamily};
  font-size: 13px;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: ${theme.radiusPill};
  color: #ffffff;
  background: ${({ danger }) => (danger ? theme.danger : theme.primary)};
  transition: opacity 150ms ease;

  &:hover {
    opacity: 0.9;
  }
`;

const ClearBtn = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.12);

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export { BulkActionBar };
